<template>
    <div>
      <v-chip class="mr-2 mb-2"
              v-for="tag in items"
              :key="tag"
              small
      >
        {{ tagNameFromHandle(tag) }}
      </v-chip>
    </div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: "TagsDisplay",
  computed: {
    ...mapGetters([
      'tags',
    ]),
  },
  methods: {
    tagNameFromHandle(handle) {

      const tag = this.tags.filter(function (value) {
        return value.handle === handle;
      });

      return tag[0].name;
    },
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>